import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  key = '123'
  constructor() { }

  encryptionAES(id: string) {
    // Encrypt
    // const ciphertext = CryptoJS.AES.encrypt(id, this.key.trim());
    // return ciphertext.toString();

    try {
      const ciphertext = CryptoJS.AES.encrypt(id, this.key).toString();
      return ciphertext.replace(/\//g, '-').replace(/\\/g, '_');
    } catch (e) {
      console.log(e);
    }
  }

  decryptionAES(id: string) {
    // Decrypt
    // const bytes = CryptoJS.AES.decrypt(id, this.key.trim());
    // const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    // return plaintext;
    try {
      const safeMsg = id.replace(/-/g, '/').replace(/_/g, '\\');
      const bytes = CryptoJS.AES.decrypt(safeMsg, this.key);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return id;
    } catch (e) {
      console.log(e);
    }
  }
}
